import { userRoles as ur } from "../../assets/const/userRole";
import AdUnitsPage from "../pages/addUnits/AdUnitsPage";
import DashboardPage from "../pages/dashboard/dashboardPage";
import Demand from "../pages/demand/DemandForm";
import { DemandPartner } from "../pages/demand/DemandPartnerForm";
import ManageDemand from "../pages/demand/ManageDemand";
import ManageDemandPartner from "../pages/demand/ManageDemandPartner";
import Dooh from "../pages/dooh/Dooh";
import NewDoohCampaign from "../pages/dooh/NewDoohCampaign";
import Notifications from "../pages/notifications/Notifications";
import SavedReports from "../pages/reports/SavedReports";
import NewRoute from "../pages/routes/NewRoute";
import RoutesPage from "../pages/routes/RoutesPage";
import ManageSupply from "../pages/supply/ManageSupply";
import ManageSupplyPartner from "../pages/supply/ManageSupplyPartner";
import Supply from "../pages/supply/SupplyForm";
import SupplyPartner from "../pages/supply/SupplyPartnerForm";
import NewSupportPage from "../pages/support/NewSupportPage";
import Support from "../pages/support/Support";

export const AllRoutes = [
    {
        path: '/dashboard',
        element: <DashboardPage/>,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_SUPPLY,ur.ROLE_INTERMEDIARY_DEMAND,ur.ROLE_INTERMEDIARY_BILLING,ur.ROLE_INTERMEDIARY_REPORT,ur.ROLE_USER]
    },
    {
        path: '/supply-partner',
        element: <ManageSupplyPartner/>,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN, ur.ROLE_INTERMEDIARY_SUPPLY,ur.ROLE_USER]
    },
    {
        path: '/supply',
        element: <ManageSupply/>,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN, ur.ROLE_INTERMEDIARY_SUPPLY,ur.ROLE_USER]
    },
    {
        path: '/supply-partner/create',
        element: <SupplyPartner />,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_SUPPLY,ur.ROLE_USER]
    },
    {
        path: '/supply-partner/edit/:id',
        element: <SupplyPartner />,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_SUPPLY,ur.ROLE_USER]
    },
    {
        path: '/supply/create',
        element: <Supply />,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_SUPPLY,ur.ROLE_USER]
    },
    {
        path: '/supply/edit/:id',
        element: <Supply />,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_SUPPLY,ur.ROLE_USER]
    },
    {
        path: '/demand-partner',
        element: <ManageDemandPartner/>,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN, ur.ROLE_INTERMEDIARY_DEMAND,ur.ROLE_USER]
    },
    {
        path: '/demand',
        element: <ManageDemand/>,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN, ur.ROLE_INTERMEDIARY_DEMAND,ur.ROLE_USER]
    },
    {
        path: '/demand-partner/create',
        element: <DemandPartner />,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_DEMAND,ur.ROLE_USER]
    },
    {
        path: '/demand-partner/edit/:id',
        element: <DemandPartner />,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_DEMAND,ur.ROLE_USER]
    },
    {
        path: '/demand/create',
        element: <Demand />,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_DEMAND,ur.ROLE_USER]
    },
    {
        path: '/demand/:edit/:id',
        element: <Demand />,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_DEMAND,ur.ROLE_USER]
    },
    {
        path: '/routes',
        element: <RoutesPage />,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_DEMAND,ur.ROLE_USER]
    },
    {
        path: '/adunits',
        element: <AdUnitsPage />,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_USER]
    },
    {
        path: '/support',
        element: <Support />,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_SUPPLY,ur.ROLE_INTERMEDIARY_DEMAND,ur.ROLE_INTERMEDIARY_BILLING,ur.ROLE_INTERMEDIARY_REPORT,ur.ROLE_USER]
    },
    {
        path: '/dooh',
        element: <Dooh />,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_USER]
    },
    {
        path: '/notifications',
        element: <Notifications />,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_USER]
    },
    {
        path: '/campaign/create',
        element: <NewDoohCampaign />,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_USER]
    },
   
    {
        path: '/routes/create',
        element: <NewRoute />,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_USER]
    },
    {
        path: '/routes/edit/:id',
        element: <NewRoute />,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_USER]
    },
   
    {
        path: '/ticket/create',
        element: <NewSupportPage />,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_USER]
    },
    {
        path: '/savedReports',
        element: <SavedReports />,
        permissions: [ur.ROLE_ADMIN,ur.ROLE_INTERMEDIARY_ADMIN,ur.ROLE_INTERMEDIARY_REPORT,ur.ROLE_USER,ur.ROLE_INTERMEDIARY_DEMAND,ur.ROLE_INTERMEDIARY_SUPPLY]
    },
];